import React from 'react';
import {
  Button, Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Paper,
  Typography
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import EventIcon from '@material-ui/icons/Event';
import SecurityIcon from '@material-ui/icons/Security';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { GiReceiveMoney } from "react-icons/gi";
import { MdSystemUpdateAlt } from "react-icons/md";
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { text } from '../modules/languages/index';
import UrunSatisBilgileri from './ProductSalesData';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {},
  submitButtonWarranty: {
    marginTop: theme.spacing(1),
    width: '100%'
  },
  dateContainer: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#f8f9fa',
    borderLeft: `5px solid ${theme.palette.primary.main}`, // Ana garanti için mavi çizgi
    marginBottom: theme.spacing(2),
    transition: '0.3s',
    '&:hover': {
      backgroundColor: '#f1f3f5',
    }
  },
  ekDateContainer: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#fff9db', // Ek garanti için hafif sarı/altın tonu
    borderLeft: `5px solid #fcc419`,
    marginBottom: theme.spacing(2),
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: '1.2rem',
  },
  dateText: {
    fontWeight: 600,
    letterSpacing: '0.5px',
  }
}));
function GarantiDetay({ onClose, FisNo, readonly, tasks }) {
  const classes = useStyles();
  const [garantidetay, setgarantidetay] = useState([]);
  const [UrunData, setUrunData] = useState(false);
  const UrunDataAc = () => [
    setUrunData(true)
  ]
  const UrunDataKapat = () => {
    setUrunData(false)
  }

  let GarantiDetayData = readonly ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : loadBaslandiJob();

  if (!readonly && (!GarantiDetayData || GarantiDetayData.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      GarantiDetayData = loadBaslandiJob();
    }
  }

  var KulModelKodu = GarantiDetayData[0]?.KUL_MODEL_KODU;
  var Uyil = GarantiDetayData[0]?.UYIL;
  var Udonem = GarantiDetayData[0]?.UDONEM;
  var SeriNo = GarantiDetayData[0]?.SERINO;
  var NitelikKodu = GarantiDetayData[0]?.NITELIK_KODU;
  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      axios.get('/GetArtemisWarranty/' + (KulModelKodu || '-1') + '/' + Uyil + '/' + Udonem + '/' + SeriNo + '/' + NitelikKodu).then(response => {
        if (mounted) {
          const Deger = response.data;
          setgarantidetay(Deger);
        }
      }).catch(error => {
        setgarantidetay([]);
        logger.error("Hata detayı:", error.message);
      });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [KulModelKodu, Uyil, Udonem, SeriNo, NitelikKodu]);

  if (garantidetay.length === 0) {
    return null;
  }


  return (
    <Grid container spacing={1} >
      <Grid container spacing={2}>
        {/* Standart Garanti Bölümü */}
        <Grid item xs={12}>
          <Paper className={classes.dateContainer}>
            <div className={classes.titleWrapper}>
              <EventIcon className={classes.icon} />
              <Typography variant="overline" color="textSecondary">
                {text("Baslangic_Bitis_Tarihi")}
              </Typography>
            </div>
            <Typography variant="h6" className={classes.dateText}>
              {garantidetay?.[0]?.GARANTI_BASLANGIC_TARIHI}
              <span style={{ margin: '0 8px', color: '#adb5bd' }}>—</span>
              {garantidetay?.[0]?.GARANTI_BITIS_TARIHI}
            </Typography>
          </Paper>
        </Grid>

        {/* Ek Garanti Bölümü */}
        <Grid item xs={12}>
          <Paper className={classes.ekDateContainer}>
            <div className={classes.titleWrapper}>
              <SecurityIcon className={classes.icon} style={{ color: '#f59f00' }} />
              <Typography variant="overline" style={{ color: '#868e96' }}>
                {text("Ekgaranti_Baslangic_Bitis_Tarihi")}
              </Typography>
            </div>
            <Typography variant="h6" className={classes.dateText}>
              {garantidetay?.[0]?.EK_GARANTI_BASLANGIC_TARIHI || ''}
              <span style={{ margin: '0 8px', color: '#adb5bd' }}>—</span>
              {garantidetay?.[0]?.EK_GARANTI_BITIS_TARIHI || ''}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="contained"
          color="secondary"
          fullWidth
          onClick={UrunDataAc}
          disabled={readonly}
          className={classes.submitButtonWarranty}
          endIcon={<GiReceiveMoney>İncele</GiReceiveMoney>}
        >
          Ürün Satış Bİlgİlerİ
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="contained"
          color="secondary"
          fullWidth
          disabled={readonly}
          onClick={() => onClose(garantidetay)}
          className={classes.submitButtonWarranty}
          endIcon={<MdSystemUpdateAlt>Yukle</MdSystemUpdateAlt>}
        >
          Sİstem Tarİhİnİ Kullan
        </Button>
      </Grid>

      <Dialog
        open={UrunData}
        fullWidth={true}
        onClose={UrunDataKapat}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Ürün Satış Bilgileri
        </DialogTitle>
        <Divider />
        <DialogContent>
          <UrunSatisBilgileri FisNo={FisNo} loading={true} />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={UrunDataKapat}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

GarantiDetay.propTypes = {
  className: PropTypes.string,
  FisNo: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

GarantiDetay.defaultProps = {
  open: false,
  onClose: () => { }
};


export default connect(
  state => ({ tasks: state.tasks1 })
)(GarantiDetay);
